/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Project_Overview_Chip2_AnswerInputs */



/**
* | output |
* | --- |
* | "Chats, project instructions, attached references, and any artifacts you create together. Members can be given viewer, editor, or admin access." |
*
* @param {Uno_Edu_Project_Overview_Chip2_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_project_overview_chip2_answer = /** @type {((inputs?: Uno_Edu_Project_Overview_Chip2_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Project_Overview_Chip2_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Chats, Projektanweisungen, angehängte Referenzen und alle gemeinsam erstellten Artefakte. Mitgliedern kann Betrachter-, Bearbeiter- oder Administratorzugriff gewährt werden.")
	return /** @type {LocalizedString} */ ("Chats, project instructions, attached references, and any artifacts you create together. Members can be given viewer, editor, or admin access.")
});